import { httpCreate } from './http';

const http = httpCreate('/srv/ht-user');

export const htUser = {
	getList(activityId, params) {
		return http.get(`/${activityId}`, { params });
	},
};
